import * as React from 'react';

function SvgHumidity(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 511.4 511.4"
      {...props}
    >
      <circle cx={303.7} cy={399.4} r={16} />
      <circle cx={207.7} cy={239.4} r={16} />
      <path d="M344.6 112.2c-26.2-33.4-53.2-67.9-75-104.9-5.8-9.8-21.8-9.8-27.6 0-21.9 37-48.9 71.5-75.1 104.9-53.1 67.7-103.2 131.6-103.2 207.2 0 105.9 86.1 192 192 192s192-86.1 192-192c0-75.6-50.1-139.5-103.1-207.2zm-136.9 79.2c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.6-48 48-48zm-20.6 219.4c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.3 16.4 0 22.6l-160 160zm116.6 36.6c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z" />
    </svg>
  );
}

export default SvgHumidity;
